import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  delete_Record,
  errorMessage,
  successMessage,
} from "../CommonFunctions";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import swal from "sweetalert";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_GetTestMethodsList,
  POST_GetTestMethodsReviseHistList,
  POST_GetTestMethodsVerificationHistoryList,
  POST_TestMethodsActiveInActive,
  POST_TestMethodsDelete,
  POST_TestMethodsExport,
  POST_TestMethodsVerifiedUpdate,
} from "../../../helpers/url_helper";
import { useFilter } from "../../../../context/FilterContext";

const TestMethod = () => {
  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const { filter, updateFilter } = useFilter();

  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "test-method" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "test-method" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);
  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "test-method" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "test-method" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [showReviseHistoryModal, setShowReviseHistoryModal] = useState(false);
  const [testMethodList, setTestMethodList] = useState([]);
  const [testMethodHistory, setTestMethodHistory] = useState([]);
  const [testMethodHistoryModal, setTestMethodHistoryModal] = useState(false);
  const [testMethodsVerifiedModal, setTestMethodsVerifiedModal] =
    useState(false);
  const [testMethodID, setTestMethodID] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [listOfTestMethodReviseHist, setListOfTestMethodReviseHist] = useState(
    []
  );

  const [
    listOfTestMasterTestMethodDetails,
    setListOfTestMasterTestMethodDetails,
  ] = useState([]);
  const [
    listOfTestMasterStandardParametersDetails,
    setListOfTestMasterStandardParametersDetails,
  ] = useState([]);

  const [showReviseHistDetailModal, setShowReviseHistDetailModal] =
    useState(false);

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const yesNoOptions = [
    { label: "All", value: -1 },
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const validationSchema = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      Status: filter && filter?.page == "test-method" ? filter?.Status : -1,
      Search: filter && filter?.page == "test-method" ? filter?.Search : "",
      IsVerified:
        filter && filter?.page == "test-method" ? filter?.IsVerified : -1,
      IsNABL: filter && filter?.page == "test-method" ? filter?.IsNABL : -1,

      // Search: "",
      // Status: -1,
      // IsVerified: -1,
      // IsNABL: -1,
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { Search, Status, IsVerified, IsNABL },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      Status: -1,
      Search: "",
      IsVerified: -1,
      IsNABL: -1,
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "test-method",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      Status: Status,
      Search: Search ? Search : "",
      IsVerified: IsVerified,
      IsNABL: IsNABL,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      Status: Status,
      Verified: IsVerified,
      NABL: IsNABL,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    await post(POST_GetTestMethodsList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setTestMethodList(response?.TestMethodsList);
        setIsLoading(false);
        if (page > 1 && response?.TestMethodsList?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    getData(currentPage, currentSizePerPage);
  };

  const TestMethod_History = (TestMethodID) => {
    setIsLoading(true);
    setTestMethodHistory("");
    setTestMethodHistoryModal(true);
    GetTestMethodsReviseHistList(TestMethodID);

    let payload = {
      TestMethodIDEncrypt: TestMethodID,
    };
    post(POST_GetTestMethodsVerificationHistoryList, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          setTestMethodHistory(response?.TestMethodsVerificationHistoryList);
        }
        // } else {
        //   // swal("Error!", response?.Message, "error");
        //   errorMessage(response?.Message);
        // }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData(1, currentSizePerPage);
  }, [sortBy, orderBy]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Search: Search,
      Status: Status,
      NABL: IsNABL,
      Verified: IsVerified,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    };
    post(POST_TestMethodsExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          //  swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const TestMethod_Verified = (TestMethodID, TestMethodName) => {
    formiksetTestMethodsVerified.resetForm();
    setTestMethodsVerifiedModal(true);
    formiksetTestMethodsVerified.setFieldValue(
      "TestMethodIDEncrypt",
      TestMethodID
    );
    formiksetTestMethodsVerified.setFieldValue(
      "TestMethodName",
      TestMethodName
    );
  };

  const validationSchemaTestMethodsVerified = Yup.object().shape({
    VerificationRemarks: Yup.string()
      .trim()
      .required("Verification Remarks is required field"),
  });

  const formiksetTestMethodsVerified = useFormik({
    validationSchema: validationSchemaTestMethodsVerified,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestMethodsVerified(values, formikHelpers),
    initialValues: {
      TestMethodIDEncrypt: testMethodID,
      VerificationRemarks: "",
      TestMethodName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { TestMethodName },
  } = formiksetTestMethodsVerified;

  const handleValidSubmitTestMethodsVerified = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      TestMethodIDEncrypt: values.TestMethodIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      VerificationDoneByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      VerificationRemarks: values.VerificationRemarks,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(POST_TestMethodsVerifiedUpdate, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          //swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            formiksetTestMethodsVerified.resetForm();
            setTestMethodsVerifiedModal(false);
            getData();
          }, 1000);
        } else {
          //swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    setIsLoading(false);
  };

  const GetTestMethodsReviseHistList = async (TestMethodID) => {
    setIsLoading(true);
    post(POST_GetTestMethodsReviseHistList, {
      TestMethodIDEncrypt: TestMethodID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // formik.setFieldValue(
          //   "ListOfTestMethodReviseHist",
          //   response?.ListOfTestMethodRevise
          // );
          setListOfTestMethodReviseHist(response?.ListOfTestMethodRevise);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Test Method</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>
                  {"  "}
                  Reset
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getData();
                    //   setShowFilter(false);
                  }}
                >
                  <i className="fa-solid fa-refresh me-2"></i> Reload
                </button>
                <button
                  type="button"
                  // className="btn btn-primary btn-sm me-2"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 20 && x?.IsExport)
                  ?.length > 0 ? (
                  <Link
                    // className="btn btn-primary light btn-sm me-2"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={exportReport}
                  >
                    <i className="fa-solid fa-file-excel" /> Export Report
                  </Link>
                ) : (
                  ""
                )}
                {AuthUser?.UserType !== 1 ||
                formsList?.filter((x) => x?.FormID == 20 && x?.IsAdd)?.length >
                  0 ? (
                  <Link
                    to="/add-test-method"
                    // className="btn btn-primary btn-sm"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fa-solid fa-plus"></i> Add Test Method
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={3}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                            autoFocus={isFilterExpanded}
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Status"
                            name="Status"
                            placeholder={"Select Status"}
                            options={statusOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="Verified"
                            name="IsVerified"
                            placeholder={"Select Verified"}
                            options={yesNoOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label="NABL"
                            name="IsNABL"
                            placeholder={"Select NABL"}
                            options={yesNoOptions}
                            component={CustomSelect}
                            isClearable={false}
                            menuPosition="fixed"
                          />
                        </Col>
                        <Col lg={3}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                // className="btn btn-primary btn-sm mb-1"
                                className="btn btn-primary btn-sm"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  aria-hidden="true"
                                ></i>{" "}
                                Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}
              <div
                id="TestMethod-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="TestMethod-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th width="12%"></th>
                      <th
                        style={{
                          width: "43%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("TestMethod");
                        }}
                      >
                        {" "}
                        Method Name{" "}
                        <span className="ml-1">
                          {sortBy == "TestMethod" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "10%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("IsNABL");
                        }}
                      >
                        NABL
                        <span className="ml-1">
                          {sortBy == "IsNABL" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "25%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickSorting("IsVerified");
                        }}
                      >
                        Verified{" "}
                        <span className="ml-1">
                          {sortBy == "IsVerified" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                      <th
                        style={{
                          width: "20%",
                          cursor: "pointer",
                          textAlign: "left",
                        }}
                        onClick={() => {
                          handleClickSorting("VerificationValidityDate");
                        }}
                      >
                        Expired Date{" "}
                        <span className="ml-1">
                          {sortBy == "VerificationValidityDate" ? (
                            orderBy == "desc" ? (
                              <i
                                className="fa fa-arrow-down ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            ) : (
                              <i
                                className="fa fa-arrow-up ms-2 fs-14"
                                style={{ opacity: "0.7" }}
                              />
                            )
                          ) : (
                            <i
                              className="fa fa-sort ms-2 fs-14"
                              style={{ opacity: "0.3" }}
                            />
                          )}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {testMethodList?.length > 0 ? (
                      testMethodList?.map((item, indx) => (
                        <tr key={indx}>
                          <td>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 20 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/edit-test-method/${window.btoa(
                                  item.TestMethodIDEncrypt
                                )}`}
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Edit"
                              >
                                {SVGICON.EditPrimary}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 20 && x?.IsActive
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className={`icon-box icon-box-md bg-${
                                //   item.IsActive == true ? "success" : "danger"
                                // }-light me-1`}
                                className={`icon-box icon-box-md me-1`}
                                title={
                                  item.IsActive == true ? "Active" : "Inactive"
                                }
                                onClick={() => {
                                  ActiveInactive_Record(
                                    item.IsActive,
                                    POST_TestMethodsActiveInActive,
                                    {
                                      TestMethodIDEncrypt:
                                        item.TestMethodIDEncrypt,
                                      IsActive: !item.IsActive,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.TestMethod
                                  );
                                }}
                              >
                                <i
                                  className={`fa fa-circle fs-15 ${
                                    item.IsActive == true
                                      ? "text-success"
                                      : "text-danger"
                                  }`}
                                ></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 20 && x?.IsDelete
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-danger-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Delete"
                                onClick={() => {
                                  delete_Record(
                                    POST_TestMethodsDelete,
                                    {
                                      TestMethodIDEncrypt:
                                        item.TestMethodIDEncrypt,
                                      ModifiedByEncrypted:
                                        AuthUser?.ReferenceIDEncrypt
                                          ? AuthUser?.ReferenceIDEncrypt
                                          : "0",
                                    },
                                    setIsLoading,
                                    fnCallback,
                                    item.TestMethod
                                  );
                                }}
                              >
                                {SVGICON.DeleteDanger}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 20 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Verify"
                                onClick={() => {
                                  TestMethod_Verified(
                                    item.TestMethodIDEncrypt,
                                    item.TestMethod
                                  );
                                }}
                              >
                                {/* <i className="fa fa-check-circle"></i> */}

                                {item.IsVerified
                                  ? SVGICON.Verified
                                  : SVGICON.Unverified}
                              </Link>
                            ) : (
                              ""
                            )}
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 20 && x?.IsEdit
                            )?.length > 0 ? (
                              <Link
                                to={`/revise-test-method/${window.btoa(
                                  item.TestMethodIDEncrypt
                                )}`}
                                // className="icon-box icon-box-md bg-primary-light me-1"
                                className="icon-box icon-box-md me-1"
                                title="Revise"
                              >
                                <i className="fa fa-refresh"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            <Link
                              // className="icon-box icon-box-md bg-primary-light"
                              className="icon-box icon-box-md me-1"
                              title="History"
                              onClick={() => {
                                TestMethod_History(item.TestMethodIDEncrypt);
                              }}
                            >
                              <i className="fa fa-history"></i>
                            </Link>
                          </td>
                          <td>{item.TestMethod}</td>
                          <td>{item.IsNABL ? "Yes" : "No"}</td>
                          <td>
                            {item.IsVerified ? "Yes" : "No"}
                            {" - "}
                            {item.VerificationDoneBy} {" - "}
                            {item.VerificationDateTime}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {item.VerificationValidityDate}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={testMethodHistoryModal}
          onHide={setTestMethodHistoryModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div>
              <Modal.Header>
                <Modal.Title>Test Method History</Modal.Title>
                <div className="d-flex align-items-center">
                  <div>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => {
                        setShowReviseHistoryModal(true);
                      }}
                    >
                      View Revise History
                    </Link>
                  </div>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setTestMethodHistoryModal(false)}
                  ></button>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="table-responsive active-projects style-1 shorting">
                  <div
                    id="TestMethod-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="TestMethod-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead className="thead-light">
                        <tr role="row">
                          <th>Test Method</th>
                          <th>Verification Done By</th>
                          <th>Verification Date</th>
                          <th style={{ textAlign: "left" }}>
                            Verification Validity Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {testMethodHistory?.length > 0 ? (
                          testMethodHistory?.map((MethodHistory, mIndx) => (
                            <tr role="row" className="odd" key={mIndx}>
                              <td>{MethodHistory.TestMethod}</td>
                              <td>{MethodHistory.VerificationDoneByName}</td>
                              <td>{MethodHistory.VerificationDateTime}</td>
                              <td style={{ textAlign: "left" }}>
                                {MethodHistory.VerificationValidityDate}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={4}
                              style={{
                                textAlign: "left",
                              }}
                            >
                              <div className="mt-1 ml-1 mb-2">
                                {"No Record Found..."}
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Modal.Body>
              {showReviseHistoryModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
              {/* <Modal.Footer>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={() => setTestMethodHistoryModal(false)}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Modal.Footer> */}
            </div>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={testMethodsVerifiedModal}
          onHide={setTestMethodsVerifiedModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formiksetTestMethodsVerified}>
              <Form onSubmit={formiksetTestMethodsVerified.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    Test Methods Verified ({TestMethodName})
                  </Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setTestMethodsVerifiedModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Verification Remarks"
                        name="VerificationRemarks"
                        rows={5}
                        placeholder={"Enter Verification Remarks"}
                        component={CustomTextArea}
                        maxLength={500}
                        required
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Verify
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setTestMethodsVerifiedModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showReviseHistoryModal}
          onHide={setShowReviseHistoryModal}
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title> Test Method Revise History</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowReviseHistoryModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="ReviseHistory-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="ReviseHistory-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <th width="45%">Test Method</th>
                            <th width="15%">Validity Date</th>
                            <th width="15%">Effective Date</th>
                            <th width="10%">NABL</th>
                            <th width="5%">File</th>
                            <th width="5%" style={{ textAlign: "left" }}>
                              Mapped
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {listOfTestMethodReviseHist?.length > 0 ? (
                            listOfTestMethodReviseHist?.map((item, indx) => (
                              <tr key={indx}>
                                <td>{indx + 1}</td>
                                <td>{item?.TestMethod}</td>
                                <td>{item?.VerificationValidityDate}</td>
                                <td>{item?.EffectiveDate}</td>
                                <td>{item?.IsNABL ? "Yes" : "No"}</td>
                                <td>
                                  {item?.TestMethodRefDocFilePath ? (
                                    <Link
                                      to="#"
                                      className="fs-14"
                                      title="Download"
                                      onClick={() => {
                                        window.open(
                                          item?.TestMethodRefDocFilePath,
                                          "_blank"
                                        );
                                      }}
                                    >
                                      {SVGICON.Download}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="View Mapped Detail"
                                    onClick={() => {
                                      setShowReviseHistDetailModal(true);

                                      setListOfTestMasterTestMethodDetails(
                                        item?.ListOfTestMasterTestMethod
                                      );
                                      setListOfTestMasterStandardParametersDetails(
                                        item?.ListOfTestMasterStandardParameters
                                      );
                                    }}
                                  >
                                    {SVGICON.NoteText}
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              {showReviseHistDetailModal == true && (
                <div className="fade modal-backdrop show"></div>
              )}
            </Modal.Body>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showReviseHistDetailModal}
          onHide={setShowReviseHistDetailModal}
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Revise History</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowReviseHistDetailModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={6}>
                  <div className="card mb-2" style={{ height: "auto" }}>
                    <div className="card-header p-2 ps-3 pb-0">
                      <label>Mapped Test</label>
                    </div>
                    <div className="card-body fs-14 pt-1 pb-2">
                      {listOfTestMasterTestMethodDetails?.length > 0 ? (
                        <ul className="unorder-list ps-3">
                          {listOfTestMasterTestMethodDetails?.map(
                            (item, indx) => (
                              <li key={indx}>{item.TestName}</li>
                            )
                          )}
                        </ul>
                      ) : (
                        <span className="fs-12">No data found...</span>
                      )}
                    </div>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="card mb-2" style={{ height: "auto" }}>
                    <div className="card-header p-2 ps-3 pb-0">
                      <label>Mapped Element</label>
                    </div>
                    <div className="card-body fs-14 pt-1 pb-2">
                      {listOfTestMasterStandardParametersDetails?.length > 0 ? (
                        <ul className="unorder-list ps-3">
                          {listOfTestMasterStandardParametersDetails?.map(
                            (item, indx) => (
                              <li key={indx}>
                                {item.ParameterHeaderDisplayName}
                              </li>
                            )
                          )}
                        </ul>
                      ) : (
                        <span className="fs-12">No data found...</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default TestMethod;
